import { Html, OrbitControls } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import * as THREE from "three";
import React, { Suspense, useRef } from "react";
import "./HomePage.style.scss";
import LoadingScene from "../loading/LoadingScene";
import StartPage from "../startPage/StartPage";
import Galaxy from "../galaxy/Galaxy";

const HomePage = () => {
    const cameraRef = useRef();

    return (
        <div>
            <div className="sidePanel">
                <Canvas
                    gl={{ devicePixelRatio: window.devicePixelRatio }}
                    className="webgl"
                    ref={cameraRef}
                    camera={{ position: [-20.37, 0.22, -5.42] }}
                    onCreated={({ gl }) => {
                        gl.shadowMap.enabled = true;
                        gl.shadowMap.type = THREE.PCFShadowMap;
                    }}
                >
                    <ambientLight intensity={0.1} position={[-1, 1, 0]} />
                    <directionalLight color="white" position={[0, 0, 5]} />

                    <Suspense
                        fallback={
                            <Html>
                                <LoadingScene />
                            </Html>
                        }
                    >
                        <StartPage />
                        <Galaxy />
                    </Suspense>
                    <OrbitControls />
                </Canvas>
            </div>
        </div>
    );
};

export default HomePage;
